import { g as getElement } from './index-1a670dd0.js';
import { i as isInstanceOf, a as isNull } from './unit-f81589b4.js';
import { g as getEventName } from './PlayerEvents-c5e0a046.js';
import { l as listen } from './dom-6e291ce0.js';

var createDeferredPromise = function createDeferredPromise() {
  var resolve;
  var promise = new Promise(function (res) {
    resolve = res;
  });
  return {
    promise: promise,
    resolve: resolve
  };
};

var openWormhole = function openWormhole(Component, props) {
  var ComponentPrototype = Component.prototype;
  var componentWillLoad = ComponentPrototype.componentWillLoad;

  ComponentPrototype.componentWillLoad = function () {
    var _this = this;

    var el = getElement(this);
    var onOpen = createDeferredPromise();
    var event = new CustomEvent('openWormhole', {
      bubbles: true,
      composed: true,
      detail: {
        consumer: this,
        fields: props,
        updater: function updater(prop, value) {
          _this[prop] = value;
        },
        onOpen: onOpen
      }
    });
    el.dispatchEvent(event);
    return onOpen.promise.then(function () {
      if (componentWillLoad) {
        return componentWillLoad.call(_this);
      }
    });
  };
};
/**
 * Finds the closest ancestor player element.
 *
 * @param ref A HTMLElement that is within the player's subtree.
 */


var findRootPlayer = function findRootPlayer(ref) {
  var root = isInstanceOf(ref, HTMLElement) ? ref : getElement(ref);
  var player = root;

  while (!isNull(player) && !/^VIME-PLAYER$/.test(player === null || player === void 0 ? void 0 : player.nodeName)) {
    player = player.parentElement;
  }

  if (isNull(player)) {
    throw Error("Can't find root player given: ".concat(root));
  }

  return player;
};
/**
 * Binds props between an instance of a given component class and it's closest ancestor player.
 *
 * @param Component A Stencil component class.
 * @param props A set of props to watch and update on the given component instance.
 */


var withPlayerContext = function withPlayerContext(Component, props) {
  return openWormhole(Component, props);
};
/**
 * Finds the closest ancestor player to the given `ref` and watches the given props for changes. On
 * a prop change the given `updater` fn is called.
 *
 * @param ref A element within any player's subtree.
 * @param props A set of props to watch and call the `updater` fn with.
 * @param updater This function is called with the prop/value of any watched properties.
 */


var usePlayerContext = function usePlayerContext(ref, props, updater, playerRef) {
  var player = playerRef !== null && playerRef !== void 0 ? playerRef : findRootPlayer(ref);
  var listeners = props.map(function (prop) {
    var event = getEventName(prop);
    return listen(player, event, function () {
      updater(prop, player[prop]);
    });
  });
  return function () {
    listeners.forEach(function (off) {
      return off();
    });
  };
};

export { findRootPlayer as f, usePlayerContext as u, withPlayerContext as w };